import {Component, Inject, OnInit, Optional} from '@angular/core';
import {GetCodebookQuery, SifrarnikDataService, SifrarnikModel} from "../../services/sifrarnik-data.service";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";

@Component({
  selector: 'app-sifrarnik-add-dialog',
  templateUrl: './sifrarnik-add-dialog.component.html',
  styleUrls: ['./sifrarnik-add-dialog.component.css']
})
export class SifrarnikAddDialogComponent implements OnInit {

  adding:boolean = false;
  originalFormValues: any;
  constructor(
    public sifrarnikDataService: SifrarnikDataService,
    public dialogRef: MatDialogRef<SifrarnikAddDialogComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public importingData: { action: string; data?: any}
  ) {
  }

  sifraData: GetCodebookQuery = {
    companyName: '',
    idNumber: '',
    code: '',
    vatNumber: ''
  }

  sifraDataEdit: GetCodebookQuery = {
    companyName: '',
    idNumber: '',
    code: '',
    vatNumber: ''
  }

  ngOnInit(): void {    
    this.sifraDataEdit = this.importingData.data
    this.originalFormValues = { ...this.sifraDataEdit };

  }

  async addNewSifraFromDialog() {
    this.adding = true;
    await this.sifrarnikDataService.addNewSifra(this.sifraData)
    this.adding = false;
    this.dialogRef.close('res')
  }

  editSifraFromDialog() {
    this.sifrarnikDataService.editSifra(this.sifraDataEdit)
    this.dialogRef.close()
  }

  isFormDirty(): boolean {
    return JSON.stringify(this.originalFormValues) !== JSON.stringify(this.sifraDataEdit);
  }

  isOneFieldFilled(): boolean {
    // Check if at least one of the idNumber or vatNumber fields is filled
    if (this.importingData.action === 'Add') {
      return !!(
        (this.sifraData?.idNumber || this.sifraData?.vatNumber) &&
        this.sifraData?.companyName &&
        this.sifraData?.code
      );
    } else {
      return !!(
        (this.sifraDataEdit?.idNumber || this.sifraDataEdit?.vatNumber) &&
        this.sifraDataEdit?.companyName &&
        this.sifraDataEdit?.code
      );
    }
  }
  
}
